import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../../../../_components/common/Navbar';
import SideNavBar from '../../../../_components/common/SideNavBar'
import { superAdminAreaData } from '../../OrgAdminArea/SidebarData'
import UtilityNav from '../../../../_components/common/UtilityNav'
import ModalComponent from '../../../../_components/common/Modal';
import { Table } from 'reactstrap';
import TableNew from '../../../../_components/common/Table';
import { addOrgAdmin } from './formData';
import tableSort from '../../../../_components/common/Sort';
import { superAdminAction } from '../../../../_actions';
import { headerPermissionAction } from '../../../../_actions/Analyze/headerPermission.action';

class ManageOrgAdmins extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            addOrgAdminModal: false,
            DeleteOrgAdminModal: false,
            MakeOrgAdminModal: false,
            sortType: false,
            orgDetails: null,
            orgId: null,
            updateModalState: false,
            updateMessage: null,
            navData: [],
            tableData: []
        }
    }

    componentDidUpdate(prevProp) {
        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        this.setState({ orgId: id })

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})

        this.props.dispatch(superAdminAction.getOrgAdminsHandler(id, () => { }))
    }

    compareBy(key) {
        return tableSort(key, this.state.sortType)
    }

    sortBy(columnKey, type) {
        this.setState({ sortType: type })
        const sortedData = this.getOrgAdmin(this.props.getOrgAdminsResponse).sort(this.compareBy(columnKey));
        this.setState({ tableData: sortedData })
    }

    toggleEntireOrgModal(showModal) {
        this.setState({
            addOrgAdminModal: showModal,
            MakeOrgAdminModal: showModal,
            DeleteOrgAdminModal: showModal,
        })
    }

    toggleaddOrgAdminModal(showModal) {
        this.setState({
            addOrgAdminModal: showModal
        })
        addOrgAdmin.map(
            (data, i) => {
                this.resetData(data)
            }
        )
    }

    resetData(data) {
        data.value = '';
        if (data.validation.required === true) {
            data.valid = false;
        }
    }

    toggleMakeOrgAdminModal(showModal) {
        this.setState({
            MakeOrgAdminModal: true,
            orgDetails: showModal
        })
    }

    toggleDeleteOrgAdminModal(showModal) {
        this.setState({
            DeleteOrgAdminModal: true,
            orgDetails: showModal
        })
    }

    toggleModal(showModal) {
        this.setState({
            modal: showModal,
        });
    }

    setUpdateModalContent = (responseData, heading) => {
        this.setState({
            updateModalState: true,
            updateMessage: {
                status: responseData.status,
                text: `<div className = " text-center">
                <p className = "font-weight-bold h6">${responseData.status === 200 ? 'Success!' : 'Error!'}</p>
                <p>${responseData.data.message}</p >
                </div > `,
                heading: heading,
                headerColor: responseData.status === 200 ? `` : `bg-danger`,
                headingIcon: responseData.status === 200 ? `fa fa-check text-white` : 'fa fa-exclamation-triangle'
            },
        })
    }

    actionSelected(data) {
        const fd = {
            'analytics_organisation_id': this.state.orgId,
            'email': data.data.email.toLowerCase()
        }
        this.props.dispatch(superAdminAction.addOrgAdminHandler(fd, (responseData) => {
            this.setUpdateModalContent(responseData, 'Add Organisation Admin');
            this.callHeaderPermissions()
        }))
        this.setState({
            tableData: []
        })
    }

    updateNavItems = () => {
        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})        
    }

    onClickDeleteOrg(type) {
        if (type === 'Remove') {
            const fd = {
                "admin_id": this.state.orgDetails.id
            }
            this.props.dispatch(superAdminAction.removeOrgAdminHandler(fd, this.state.orgId, (responseData) => {
                this.setUpdateModalContent(responseData, 'Remove Primary Admin');
                this.callHeaderPermissions()
            }))
        }
        this.setState({
            DeleteOrgAdminModal: false,
            tableData: []
        })
    }

    callHeaderPermissions = () => {
        let id = this.props.match.params.id;
        this.props.dispatch(headerPermissionAction.headerPermissionDataAction({"analytics_org_id": id},(callback_data) => {
            if(callback_data.data !== '') {
                localStorage.setItem('is_org_admin',callback_data.data.is_org_admin);
                localStorage.setItem('is_pa_user',callback_data.data.is_pa_user);
                localStorage.setItem('is_success',callback_data.data.is_super_admin);
                this.updateNavItems();
            };
        }));
    }

    onClickMakePrimaryAdmin(type) {
        if (type === 'Submit') {
            const fd = {
                "admin_id": this.state.orgDetails.id
            }
            this.props.dispatch(superAdminAction.makeOrgPrimaryAdminHandler(fd, this.state.orgId, (responseData) => {
                this.setUpdateModalContent(responseData, 'Make Primary Admin');
            }))
        }
        this.setState({
            MakeOrgAdminModal: false,
            tableData: []
        })
    }

    getOrgAdmin = (responseData) => {
        let returndata = [];
        const tableData = responseData;
        tableData !== '' &&
            tableData.map(
                (data, i) => {
                    returndata.push({
                        ...data,
                        'user__username': data.user__email + (data.is_primary_admin === true ? ' (Primary admin)' : '')
                    })
                }
            )
        return returndata
    }

    render() {
        const { getOrgAdminsResponse } = this.props;
        const tables = {
            Team: [{
                name: 'Name',
                key: 'user__username',
                link: '',
                sort: true,
                type: 'text',
                content: '',
                alignCenter: false,
                link: ''

            },
            {
                name: 'Email',
                key: 'user__email',
                link: '',
                sort: true,
                type: 'text',
                content: '',
                alignCenter: false,
                link: ''
            },
            {
                name: '',
                key: 'EDIT',
                link: '',
                sort: false,
                type: 'Button',
                content: 'Make Primary',
                alignCenter: false,
                buttonDisabled: 'is_primary_admin',
                link: '',
                title: 'Make Primary Org Admin'
            },
            {
                name: '',
                key: 'REMOVE/DELETE',
                link: '',
                sort: false,
                type: 'iconButton',
                content: 'fas fa-times-circle fas-custom',
                alignCenter: true,
                buttonDisabled: 'is_primary_admin',
                link: '',
                title: 'Remove Org Admin'
            }
            ]
        }

        return (
            <div>
                <Navbar navItems={this.state.navData} backgroundColor="dark" />
                < div className="container-post-nav">
                    <SideNavBar sideNavItems={superAdminAreaData.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="main-body-div ">
                        <h5 className="jumbo">MANAGE ORGANISATION ADMINS</h5>
                        <UtilityNav
                            actionButtons={[
                                {
                                    id: 1,
                                    name: 'Add Org Admin',
                                    toggler: this.toggleaddOrgAdminModal.bind(this),
                                    togglerModal: this.state.addOrgAdminModal,
                                    icon: 'fa fa-plus',
                                    title: 'Add Org Admin '
                                }
                            ]}
                            modal={this.toggleModal.bind(this)}
                            showModal={this.state.modal}
                        />
                        {
                            getOrgAdminsResponse !== '' &&
                            <TableNew
                                data={this.state.tableData.length === 0 ? this.getOrgAdmin(getOrgAdminsResponse) : this.state.tableData}
                                columns={tables.Team}
                                onClickEditButton={this.toggleMakeOrgAdminModal.bind(this)}
                                onClickRemoveorDeleteButton={this.toggleDeleteOrgAdminModal.bind(this)}
                                sortBy={(key) => this.sortBy(key, !this.state.sortType)}
                                sortType={this.state.sortType}
                            />
                        }

                        {
                            (getOrgAdminsResponse === '') &&
                            <p className="text-center">
                                <i className="fas fa-spinner fa-spin text-black spinner-position" ></i>
                                &nbsp;Loading</p>
                        }

                        {
                            this.state.addOrgAdminModal &&
                            <ModalComponent
                                showModal={this.state.addOrgAdminModal}
                                heading="Add Organisation Admin"
                                formData={addOrgAdmin}
                                action={this.actionSelected.bind(this)}
                                toggleEntireModal={this.toggleEntireOrgModal.bind(this)}
                                footerFormSubmitButton={['Add', 'Cancel']}
                            />
                        }

                        {
                            this.state.MakeOrgAdminModal &&
                            <ModalComponent
                                showModal={this.state.MakeOrgAdminModal}
                                heading="Make Primary Admin"
                                htmlText={`<div className = "ml-1 ml-md-3 pl-1 pl-md-3 " >
                                <p className="">Are you sure you want to make the primary admin?</p>
                                <span>Name : </span> <span className='font-weight-bold '>&nbsp;${this.state.orgDetails.user__email}</span>
                                <br />
                                <span>Email : </span> <span className='font-weight-bold '>&nbsp;${this.state.orgDetails.user__email}</span></div > `}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Submit',
                                }, {
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => this.onClickMakePrimaryAdmin(type)}
                                toggleEntireModal={this.toggleEntireOrgModal.bind(this)}
                            />
                        }

                        {
                            this.state.DeleteOrgAdminModal &&
                            <ModalComponent
                                showModal={this.state.DeleteOrgAdminModal}
                                heading="Remove Organisation Admin"
                                toggleEntireModal={this.toggleEntireOrgModal.bind(this)}
                                htmlText={`<div className = "ml-1 ml-md-3 pl-1 pl-md-3 ">
                                <p className="">Are you sure you want to remove the organisation admin below?</p>
                                <span>Email : </span><span className = 'font-weight-bold '>&nbsp;${this.state.orgDetails.user__email}</span>
                                <br/>
                                <span> Name : </span><span className = 'font-weight-bold '>&nbsp;${this.state.orgDetails.user__email}</span></div>`}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Remove',
                                }, {
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => this.onClickDeleteOrg(type)}
                            />
                        }

                        {
                            this.state.updateModalState &&
                            <ModalComponent
                                showModal={this.state.updateModalState}
                                heading={this.state.updateMessage.heading}
                                headerColor={this.state.updateMessage.headerColor}
                                headingIcon={this.state.updateMessage.headingIcon}
                                toggleEntireModal={() => this.setState({ updateModalState: false })}
                                htmlText={this.state.updateMessage.text}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Close',
                                }]}
                                responseHandler={(type) => this.setState({ updateModalState: false })}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }
}



function mapStateToProps(state) {
    const { getOrgAdminsLoading } = state.getOrgAdmins;
    const getOrgAdminsError = state.getOrgAdmins.error;
    const getOrgAdminsResponse = (!getOrgAdminsLoading && !getOrgAdminsError) ? state.getOrgAdmins.data.data.admin_list : '';


    //Header Permission
    const { headPerLoading } = state.headerPermissionReducer
    const headPerLoadingError = state.headerPermissionReducer.error
    const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';
    return {
        getOrgAdminsResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError
    }
}

export default connect(mapStateToProps)(ManageOrgAdmins);



// WEBPACK FOOTER //
// ./src/_pages/Organzation/SuperAdminArea/ManageOrgAdmins/index.js